/**
 * Persist date filter (startdate, enddate) in localStorage so it survives refresh.
 * Use a unique cacheKey per screen (e.g. sale list, purchase list, transaction list).
 */

const CACHE_KEYS = {
  SALE_LIST: "saleListDateFilter",
  PURCHASE_LIST: "purchaseListDateFilter",
  TRANSACTION_LIST: "transactionListDateFilter",
  SALES_ORDER_LIST: "salesOrderListDateFilter",
  SALES_ORDER_REPORTS: "salesOrderReportsDateFilter",
  PURCHASE_ORDER_REPORTS: "purchaseOrderReportsDateFilter",
  DASHBOARD: "dashboardDateFilter",
};

function isValidDateString(str) {
  if (typeof str !== "string" || !str.trim()) return false;
  const t = new Date(str).getTime();
  return !Number.isNaN(t);
}

/**
 * Get cached date filter from localStorage.
 * @param {string} cacheKey - Key from CACHE_KEYS or custom string
 * @returns {{ startdate: string, enddate: string } | null} YYYY-MM-DD strings or null
 */
function getCachedDateFilter(cacheKey) {
  try {
    const raw = localStorage.getItem(cacheKey);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (
      p &&
      p.startdate &&
      p.enddate &&
      isValidDateString(p.startdate) &&
      isValidDateString(p.enddate)
    ) {
      return { startdate: p.startdate, enddate: p.enddate };
    }
  } catch (e) {}
  return null;
}

/**
 * Normalize value to YYYY-MM-DD string (accepts moment or Date or string).
 */
function toDateString(val) {
  if (val == null) return "";
  if (typeof val === "string") return val;
  if (val.format && typeof val.format === "function") return val.format("YYYY-MM-DD");
  if (val instanceof Date) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, "0");
    const d = String(val.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return "";
}

/**
 * Save date filter to localStorage.
 * @param {string} cacheKey - Key from CACHE_KEYS or custom string
 * @param {{ startdate?: string|moment.Moment|Date, enddate?: string|moment.Moment|Date }} payload
 */
function setCachedDateFilter(cacheKey, payload) {
  try {
    const startdate = toDateString(payload?.startdate);
    const enddate = toDateString(payload?.enddate);
    if (startdate && enddate) {
      localStorage.setItem(cacheKey, JSON.stringify({ startdate, enddate }));
    }
  } catch (e) {}
}

export { CACHE_KEYS, getCachedDateFilter, setCachedDateFilter };
